import { startTransition, useState } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';
import { commonBreakpointsValues } from '@lmn/design-tokens/themeTokens';

export const MODAL_DESKTOP_BREAKPOINT_PX = commonBreakpointsValues['breakpoints-s'];
export const MODAL_MOBILE_BREAKPOINT_PX = MODAL_DESKTOP_BREAKPOINT_PX - 1;

export function useSsrMedia(query: string, fallbackValue?: boolean) {
  const [state, setState] = useState<boolean>(!!fallbackValue);

  useIsomorphicLayoutEffect(() => {
    let mounted = true;
    const mql = window.matchMedia(query);
    const onChange = () => {
      if (!mounted) {
        return;
      }
      startTransition(() => {
        setState(mql.matches);
      });
    };

    mql?.addEventListener?.('change', onChange);
    startTransition(() => {
      setState(mql.matches);
    });

    return () => {
      mounted = false;
      mql?.removeEventListener?.('change', onChange);
    };
  }, [query]);

  return state;
}

export function useIsMobile(isMobileDevice?: boolean) {
  return useSsrMedia(`(max-width: 767px)`, isMobileDevice);
}
export function useIsModalViewport(isMobileFallback?: boolean) {
  return useSsrMedia(`(max-width: ${MODAL_MOBILE_BREAKPOINT_PX}px)`, isMobileFallback);
}
export function useIsTablet(isTabletDevice?: boolean) {
  return useSsrMedia(`(min-width: 768px) and (max-width: 1023px)`, isTabletDevice);
}
export function useIsDesktop(isDesktopDevice?: boolean) {
  return useSsrMedia(`(min-width: 1024px)`, isDesktopDevice);
}
export function useIs1240orGreater(isDesktopDevice?: boolean) {
  return useSsrMedia(`(min-width: 1240px)`, isDesktopDevice);
}
